import { Link, styled } from '@mui/material';

import { linkStyle } from '../Link';

export const StyledLink = styled(Link)`
  vertical-align: baseline;

  ${linkStyle}
`;
